import React, { Component } from 'react'
import { PageWrapper, XMText, Header, XXLText, StyledImage, FlexWrapper, TeamCard } from '../components'

class AboutUs extends Component {
  state = {}

  render() {
    return (
      <React.Fragment>
        <Header title={'About Us'} icon="arrowBack" onClickBack={() => this.props.history.goBack()} color="#fff" />
        <PageWrapper viewPadding="22.4% 3.9% 6%" height="auto">
          <XXLText textAlign="left" color="#124b5f">
            Our Story
          </XXLText>
          <XMText color="#777777" padding="0 0 10px 0">
            We at GreenChoice are here to help you find food that aligns with your values, dietary needs, and budget.
          </XMText>
          <XMText color="#777777" padding="0 0 10px 0">
            Now more than ever, we as consumers want to buy from companies that are ethical and sustainable. We know our
            food purchases have an impact not only on our health but also on our communities and the planet.
          </XMText>
          <XMText color="#777777" padding="0 0 10px 0">
            We evaluate and score groceries for health and sustainability. Our data sources include federal agencies,
            research institutes, third-party certifiers, news sources and more. So you can spend less time doing
            research and more time enjoying great food.
          </XMText>
          <XMText color="#777777" padding="0 0 10px 0">
            Through comprehensive product scoring, personalised user feedback and increased connectivity, GreenChoice
            hopes to foster large communities of informed consumers purchasing with their values.
          </XMText>
          <FlexWrapper>
            <StyledImage src={require('../static/images/team_image.png')} height="400px" />
          </FlexWrapper>
          <XXLText font="Chivo" color="#124b5f" textAlign="left">
            Our Leaders & Advisors
          </XXLText>
          <TeamCard
            name="Varun Srivastava"
            position="Lead Data Scientist"
            description="Having knowledge is a privilege. My mission is to use this knowledge to do right by our environment and our society."
            image={require('../static/images/team/varun@3x.png')}
          />
          <TeamCard
            name="Galen Karlan-Mason"
            position="CEO & Founder"
            description="We can scale our impact to unimaginable proportions by inspiring communities through their own empowerment."
            image={require('../static/images/team/galen@3x.png')}
          />
          <TeamCard
            name="Harsh Maur"
            position="Technical Lead"
            description="My life mission is to inspire and to help people lead better lives through the use of technology."
            image={require('../static/images/team/harsh@3x.png')}
          />
          <TeamCard
            name="Barry Berman"
            position="Industry Advisor"
            description="EVP of Stop & Shop (retired)
          CEO of Bradlee’s Dept. Stores (former)"
            image={require('../static/images/team/barry@3x.png')}
            background
          />
          <TeamCard
            name="Marc Katz"
            position="Business Advisor"
            description="Founder & CEO of CustomInk
          *GC Investor"
            image={require('../static/images/team/marc@3x.png')}
            background
          />
          <TeamCard
            name="Jimmy Karlan"
            position="Creative Advisor"
            description="Director of Science Teacher Certification at Antioch University *GC Investor"
            image={require('../static/images/team/jimmy@3x.png')}
            background
          />
          <TeamCard
            name="Paul Fennely"
            position="Science Advisor"
            description="SVP of AECOM Environment (retired) Advisor at MassCEC
          *GC Investor"
            image={require('../static/images/team/paul@3x.png')}
            background
          />
          <TeamCard
            name="Doug Dagan"
            position="Legal Advisor"
            description="Environmental Attorney & Consultant"
            image={require('../static/images/team/doug@3x.png')}
            background
          />
        </PageWrapper>
      </React.Fragment>
    )
  }
}

export default AboutUs



// WEBPACK FOOTER //
// ./src/pages/AboutUs.js